import React from 'react'
import { MdStarRate } from 'react-icons/md'
import ModalLoginForVoting from '../ProfileComponent/ModalLogin';

const colors = {
    pink: "var(--primary-color)",
    grey: "rgb(201, 201, 201)"
};

const Voting = ({
    starsAvg, 
    stars, 
    allUsers, 
    currentValue, 
    hoverValue, 
    handleMouseLeave, 
    handleMouseOver, 
    handleClick, 
    isShowModal, 
    setShowModal, 
    handleClickVoting}) => {
    return (
        <>
            <div className='voting'>
                <div className="voting-wrapper">
                    <div className="average-star">Average Rating: {starsAvg} <MdStarRate/> ({allUsers})</div>
                    <p className="voting-text">
                        How would you rate this Recipe?
                    </p>
                    <div className="voting-action">
                        <div className="stars">
                            {stars.map((_, index) => (
                                <MdStarRate
                                    key={index}
                                    size={60}
                                    style={{
                                        cursor: "pointer",
                                        padding: "10px"
                                    }}
                                    color={(hoverValue || currentValue) > index ? colors.pink : colors.grey}
                                    onMouseOver={() => handleMouseOver(index + 1)}
                                    onMouseLeave={handleMouseLeave}
                                    onClick={() => handleClick(index + 1)}
                                />
                            ))}
                        </div>
                    </div>
                    <button className={currentValue > 0 ? "submit-voting active" : "submit-voting"}
                        onClick={() => handleClickVoting()}
                    >
                        SUBMIT RATING
                    </button>
                </div>
            </div>
            {isShowModal && <ModalLoginForVoting setShowModal={setShowModal} />}
        </>
    )
}

export default Voting